/**
 * @param subject {string}
 * @param message {string}
 * @returns {undefined | Promise<unknown>}
 */
function sendEmail(subject, message) {
  if (window.location.host === "localhost") {
    return;
  }

  const url = 'https://itblapi.wpenginepowered.com/wp-json/itblbackend/v1/send-email';

  const payload = {
    subject,
    message
  };

  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json; charset=utf-8'
    },
    body: JSON.stringify(payload)
  }).catch(e => {
    console.error(e);
  });
}
